import { render, staticRenderFns } from "./homeDetails.vue?vue&type=template&id=3b92a2b9&scoped=true&"
import script from "./homeDetails.vue?vue&type=script&lang=js&"
export * from "./homeDetails.vue?vue&type=script&lang=js&"
import style0 from "./homeDetails.vue?vue&type=style&index=0&id=3b92a2b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b92a2b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\胶己人\\jjr_store_reservation\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b92a2b9')) {
      api.createRecord('3b92a2b9', component.options)
    } else {
      api.reload('3b92a2b9', component.options)
    }
    module.hot.accept("./homeDetails.vue?vue&type=template&id=3b92a2b9&scoped=true&", function () {
      api.rerender('3b92a2b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homeDetails.vue"
export default component.exports